// extracted by mini-css-extract-plugin
module.exports = {"container":"LatLonInput_container__HN07Z","separator":"LatLonInput_separator__1g_jZ"};